import React from 'react'
import AccountPage from 'scenes/Account/AccountPage.component'

import EmailLoginForm from './components/EmailLoginForm'

class LoginPage extends React.PureComponent {
  render() {
    return (
      <AccountPage title="Login with your email">
        <EmailLoginForm />
      </AccountPage>
    )
  }
}

export default LoginPage
